<app-doc-viewer title="Table" subtitle="Common">
  <app-example-viewer codeFolder="common/table">
    <igo-table
      [database]="database"
      [model]="model"
      [hasFilterInput]="true"
      (select)="handleSelect($event)"
    />
  </app-example-viewer>
</app-doc-viewer>
